import { useEffectEvent, useLayoutEffect } from 'react'
import isEqual from 'lodash/isEqual'
import pick from 'lodash/pick'
import { useSelector } from 'react-redux'

import type { HTMLMeta } from '@app/constants/StoreTypes'

import { useAppDispatch } from '@app/utils/redux'

import { createUseContext } from '@app/packages/componentContext/createUseContext'

import { metaSelector, setMetaSlice } from '@app/store/slices/meta'
import { routingIsTransitioningSelector } from '@app/store/slices/routing'

/**
 * Hook to manage meta tags (title, keywords, etc...)
 */
export const useSetMeta = createUseContext((meta: Partial<HTMLMeta>) => {
  const smeta = useSelector(metaSelector, (l, r) => l.title === r.title)
  const isNavigating = useSelector(routingIsTransitioningSelector)
  const dispatch = useAppDispatch()

  const pmeta = pick(smeta, Object.keys(meta))
  const metaEqual = isEqual(meta, pmeta)

  if (IS_BROWSER) {
    const applyMeta = useEffectEvent(() => {
      if (!metaEqual && (IS_BROWSER ? !isNavigating : true)) {
        dispatch(setMetaSlice(meta))
      }
    })

    useLayoutEffect(() => {
      applyMeta()
    }, [metaEqual, dispatch])
  } else {
    dispatch(setMetaSlice(meta))
  }
})
